/**
 * Hook customizado para geolocalização
 * @module hooks/useGeolocation
 */

import { useState, useCallback } from 'react';
import { getCurrentPosition } from '../utils/geolocation';

/**
 * Hook para gerenciar captura de geolocalização
 * @returns {Object} { coordinates, loading, error, captureLocation, clearError }
 */
export const useGeolocation = () => {
    const [coordinates, setCoordinates] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const captureLocation = useCallback(async () => {
        setLoading(true);
        setError(null);
        setCoordinates(null);

        try {
            const coords = await getCurrentPosition();
            setCoordinates(coords);
            return coords;
        } catch (err) {
            setError(err.message);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    const clearError = useCallback(() => {
        setError(null);
    }, []);

    return {
        coordinates,
        loading,
        error,
        captureLocation,
        clearError
    };
};

